// extracted by mini-css-extract-plugin
module.exports = {"container":"MarketingMap_container__odzuI","video":"MarketingMap_video__3Bp2y"};